// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"c52c9853","294":"57738485","453":"1c4e21ce","614":"301052b1"}[chunkId] + ".chunk.js";
};